import {defineSlotRecipe} from '@chakra-ui/react3'

export const breadcrumbSlotRecipe = defineSlotRecipe({
    className: 'chakra-breadcrumb',
    slots: ['link', 'currentLink', 'item', 'list', 'root', 'ellipsis', 'separator'],
    base: {
        root: {
            color: 'text.primary'
        },
        list: {
            display: 'flex',
            alignItems: 'center',
            wordBreak: 'break-word',
            color: 'fg.muted',
            listStyle: 'none',
            gap: 'spacing-8'
        },
        link: {
            outline: '0',
            textDecoration: 'none',
            focusRing: 'outside',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '2',
            p: 'spacing-4',
            borderRadius: '3px',
            color: 'text.secondary',
            textStyle: 'body.xsmall',
            whiteSpace: 'nowrap',
            _hover: {
                bg: 'background.overlay.light'
            },
            _focusVisible: {
                boxShadow: 'none'
            }
        },
        currentLink: {
            display: 'inline-flex',
            alignItems: 'center',
            p: 'spacing-4',
            borderRadius: '3px',
            color: 'text.secondary',
            textStyle: 'body.xsmall',
            whiteSpace: 'nowrap',
            cursor: 'default',
            _hover: {
                bg: 'background.overlay.light'
            }
        },
        item: {
            display: 'inline-flex',
            alignItems: 'center',
            p: 'spacing-4',
            textStyle: 'body.xsmall',
            color: 'text.secondary',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
            transition: 'max-width 1s linear, opacity 1.5s ease',
            _hidden: {
                opacity: 0,
                padding: 0,
                maxWidth: 0
            }
        },
        separator: {
            color: 'icons.secondary',
            strokeWidth: '1px',
            _icon: {
                boxSize: '1em'
            },
            _rtl: {
                rotate: '180deg'
            },
            '&[data-overflow]': {
                width: 1.5,
                margin: '0 0.75rem 0 1.5rem'
            }
        },
        ellipsis: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            _icon: {
                boxSize: '1em'
            }
        }
    }
})
